import { render } from "./AnchorDetail.vue?vue&type=template&id=3222dbe5&scoped=true"
import script from "./AnchorDetail.vue?vue&type=script&lang=js"
export * from "./AnchorDetail.vue?vue&type=script&lang=js"

import "./AnchorDetail.vue?vue&type=style&index=0&id=3222dbe5&scoped=true&lang=css"

import exportComponent from "/Users/tomoiida/Dropbox/LegalNetwork/limar/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3222dbe5"]])

export default __exports__